import { useEffect, useState } from "react";
import { Loader2, Plus, Search } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { ErrorBox } from "@/components/common";
import { SelectionInfo } from "@/components/Selection";

export default function SelectionPicker({ onAdd, taken, initialTag = "" }) {
  const [tag, setTag] = useState(initialTag);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const find = async (t = tag) => {
    if (!t.trim()) return;
    setBusy(true); setErr(""); setRes(null);
    try { setRes((await api.get("/selections/by-tag", { params: { tag: t } })).data); } catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };
  useEffect(() => { if (initialTag) find(initialTag); }, [initialTag]); // eslint-disable-line react-hooks/exhaustive-deps
  const sel = res?.selection;
  return (
    <div className="space-y-3" data-testid="selection-picker">
      <div className="flex gap-2">
        <input className="k-input text-2xl font-black num text-center tracking-widest h-14 flex-1" placeholder="رقم الكبش" value={tag}
          onChange={(e) => setTag(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); find(); } }} data-testid="sel-lookup-input" />
        <button type="button" className="k-btn-primary h-14" onClick={() => find()} disabled={busy} data-testid="sel-lookup-btn">{busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Search className="w-5 h-5" />} بحث</button>
      </div>
      <ErrorBox text={err} />
      {res && !sel && (
        <div className="rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm font-bold text-amber-900" data-testid="sel-lookup-none">
          {res.sold ? `هذا الكبش مبيع مسبقًا (${res.sold.number}) – لا يمكن بيعه مجددًا.` : "لا يوجد اختيار معلق بهذا الرقم. استعمل «إدخال يدوي اعتمادًا على البطاقة الزرقاء»."}
          {res.last && <div className="mt-2 font-normal">آخر سجل لهذا الرقم: {res.last.number} – {res.last.status_label}</div>}
        </div>
      )}
      {sel && (
        <div className="rounded-xl border border-emerald-300 bg-white p-4 space-y-3" data-testid="sel-lookup-result">
          <SelectionInfo sel={sel} />
          {res.sold ? <ErrorBox text={`الكبش مبيع مسبقًا (${res.sold.number})`} /> : taken.includes(sel.ear_tag)
            ? <div className="text-sm font-bold text-emerald-700">مضاف إلى هذه البيعة</div>
            : <button type="button" className="k-btn-accent w-full" onClick={() => { onAdd(sel); setRes(null); setTag(""); }} data-testid="sel-add-to-sale-btn"><Plus className="w-5 h-5" /> إضافة هذا الكبش إلى البيعة</button>}
        </div>
      )}
    </div>
  );
}
